export class AppError extends Error {
  constructor(message: string, public code: string, public statusCode?: number, public context?: Record<string, unknown>) {
    super(message);
    this.name = 'AppError';
  }
}
export class NetworkError extends AppError {
  constructor(message = 'Network connection failed') { super(message, 'NETWORK_ERROR', 0); }
}
export class AuthError extends AppError {
  constructor(message: string, code = 'AUTH_ERROR') { super(message, code, 401); }
}
export class ValidationError extends AppError {
  constructor(message: string, public fields: Record<string, string>) { super(message, 'VALIDATION_ERROR', 400); }
}
export class PaymentError extends AppError {
  constructor(message: string, public stripeCode?: string) { super(message, 'PAYMENT_ERROR', 402); }
}
export class NotFoundError extends AppError {
  constructor(message = 'Resource not found') { super(message, 'NOT_FOUND', 404); }
}
export function handleError(error: unknown, context?: Record<string, unknown>): AppError {
  if (error instanceof AppError) { console.error(`[${error.code}]`, error.message, error.context, context); return error; }
  const appError = new AppError(error instanceof Error ? error.message : 'Unknown error', 'UNKNOWN_ERROR');
  console.error('[UNKNOWN_ERROR]', appError.message, context);
  return appError;
}
